var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12, _path13;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgAwesomeNear(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 31.407 6.572",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    clipPathUnits: "userSpaceOnUse",
    id: "m"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    style: {
      strokeWidth: 0.999999
    },
    d: "M0 0h118.914v26H0z"
  })), /*#__PURE__*/React.createElement("clipPath", {
    clipPathUnits: "userSpaceOnUse",
    id: "l"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    style: {
      strokeWidth: 0.999999
    },
    d: "M0 0h118.914v26H0z"
  })), /*#__PURE__*/React.createElement("clipPath", {
    clipPathUnits: "userSpaceOnUse",
    id: "k"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    style: {
      strokeWidth: 0.999999
    },
    d: "M0 0h118.914v26H0z"
  })), /*#__PURE__*/React.createElement("clipPath", {
    clipPathUnits: "userSpaceOnUse",
    id: "j"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    style: {
      strokeWidth: 0.999999
    },
    d: "M0 0h118.914v26H0z"
  })), /*#__PURE__*/React.createElement("clipPath", {
    clipPathUnits: "userSpaceOnUse",
    id: "i"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    style: {
      strokeWidth: 0.999999
    },
    d: "M0 0h118.914v26H0z"
  })), /*#__PURE__*/React.createElement("clipPath", {
    clipPathUnits: "userSpaceOnUse",
    id: "h"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    style: {
      strokeWidth: 0.999999
    },
    d: "M0 0h118.914v26H0z"
  })), /*#__PURE__*/React.createElement("clipPath", {
    clipPathUnits: "userSpaceOnUse",
    id: "g"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    style: {
      strokeWidth: 0.999999
    },
    d: "M0 0h118.914v26H0z"
  })), /*#__PURE__*/React.createElement("clipPath", {
    clipPathUnits: "userSpaceOnUse",
    id: "f"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    style: {
      strokeWidth: 0.999999
    },
    d: "M0 0h118.914v26H0z"
  })), /*#__PURE__*/React.createElement("clipPath", {
    clipPathUnits: "userSpaceOnUse",
    id: "e"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    style: {
      strokeWidth: 0.999999
    },
    d: "M0 0h118.914v26H0z"
  })), /*#__PURE__*/React.createElement("clipPath", {
    clipPathUnits: "userSpaceOnUse",
    id: "d"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    style: {
      strokeWidth: 0.999999
    },
    d: "M0 0h118.914v26H0z"
  })), /*#__PURE__*/React.createElement("clipPath", {
    clipPathUnits: "userSpaceOnUse",
    id: "c"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    style: {
      strokeWidth: 0.999999
    },
    d: "M0 0h118.914v26H0z"
  })), /*#__PURE__*/React.createElement("clipPath", {
    clipPathUnits: "userSpaceOnUse",
    id: "b"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    style: {
      strokeWidth: 0.999999
    },
    d: "M0 0h118.914v26H0z"
  })), /*#__PURE__*/React.createElement("clipPath", {
    clipPathUnits: "userSpaceOnUse",
    id: "a"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    style: {
      strokeWidth: 0.999999
    },
    d: "M0 0h118.914v26H0z"
  }))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M70.049 0H5.359C2.399 0 0 2.4 0 5.359v14.12c0 2.96 2.4 5.36 5.359 5.36h64.69c2.96 0 5.358-2.4 5.358-5.36V5.36C75.407 2.399 73.008 0 70.05 0Z",
    fill: "#6c6b6f",
    transform: "scale(.26458)",
    clipPath: "url(#a)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M69.823 1.843H5.584a3.876 3.876 0 0 0-3.876 3.876v13.4a3.876 3.876 0 0 0 3.876 3.876h64.24a3.876 3.876 0 0 0 3.875-3.875V5.719a3.876 3.876 0 0 0-3.876-3.876z",
    fill: "#89888e",
    transform: "scale(.26458)",
    clipPath: "url(#b)"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M7.322 7.943h2.489v2.15h-.858l-1.787 6.872H4.392ZM6.78 13.3h4.397l.546 1.869H6.234ZM9 10.093v-2.15h1.63l2.931 9.022h-2.775z",
    transform: "scale(.26458)",
    clipPath: "url(#c)"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M13.128 7.943h2.727l1.032 5.519h.052l1.275-5.52h2.167l1.275 5.52h.048l1.031-5.52h2.727l-2.315 9.023h-2.614l-1.214-4.86h-.048l-1.214 4.86h-2.614z",
    transform: "scale(.26458)",
    clipPath: "url(#d)"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M26.338 7.943h6.334v2.102h-3.698v1.44h3.468v1.95h-3.468v1.431h3.698v2.103h-6.334z",
    transform: "scale(.26458)",
    clipPath: "url(#e)"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M35.511 16.804c-.568-.216-1.01-.533-1.326-.945-.317-.416-.494-.919-.525-1.508v-.118h2.42l.012.057c.04.16.126.303.26.425.14.121.308.216.516.286.209.07.438.104.685.104.265 0 .495-.035.681-.1.19-.065.334-.16.438-.273a.587.587 0 0 0 .156-.399c0-.217-.1-.377-.303-.485-.204-.109-.555-.209-1.054-.3l-.902-.164c-.893-.16-1.573-.46-2.05-.906-.477-.447-.711-1.02-.711-1.722 0-.61.16-1.131.477-1.573.316-.443.754-.785 1.309-1.028.555-.243 1.188-.364 1.899-.364.802 0 1.474.113 2.024.338.551.226.967.546 1.258.958.29.412.446.902.472 1.466v.138h-2.419v-.06a.738.738 0 0 0-.204-.43 1.127 1.127 0 0 0-.455-.277c-.19-.065-.403-.1-.646-.1s-.442.03-.607.096a.804.804 0 0 0-.368.264.604.604 0 0 0-.126.373c0 .212.1.369.303.477.204.108.53.208.976.29l.902.165c.962.173 1.678.468 2.141.88.464.412.698.984.698 1.721 0 .629-.156 1.167-.464 1.622-.307.455-.754.81-1.34 1.058-.585.247-1.291.373-2.115.373-.776 0-1.448-.109-2.012-.326z",
    transform: "scale(.26458)",
    clipPath: "url(#f)"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M44.33 16.562a3.858 3.858 0 0 1-1.564-1.618c-.37-.702-.551-1.53-.551-2.488v-.013c0-.958.186-1.786.555-2.484a3.882 3.882 0 0 1 1.57-1.613c.676-.377 1.473-.568 2.397-.568.923 0 1.734.19 2.41.568.677.377 1.201.919 1.57 1.613.368.698.55 1.521.55 2.484v.013c0 .958-.182 1.786-.55 2.484a3.908 3.908 0 0 1-1.565 1.617c-.677.382-1.483.568-2.415.568-.932 0-1.726-.186-2.402-.568zm3.387-1.904c.273-.203.485-.494.633-.867.147-.377.225-.82.225-1.33v-.014c0-.516-.074-.962-.225-1.335-.152-.373-.365-.66-.642-.863a1.602 1.602 0 0 0-.976-.303c-.372 0-.685.1-.962.299-.278.2-.49.485-.642.858-.151.373-.225.82-.225 1.34v.013c0 .516.074.962.225 1.34.152.377.365.663.638.867.273.203.594.303.966.303.373 0 .712-.104.985-.308z",
    transform: "scale(.26458)",
    clipPath: "url(#g)"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M52.29 7.943h3.048l1.985 5.371h.044l1.986-5.371H62.4v9.022h-2.302v-5.229h-1.227l2.545-3.546-3.368 8.77h-1.414l-3.369-8.77 2.545 3.546h-1.227v5.229h-2.302V7.943Z",
    transform: "scale(.26458)",
    clipPath: "url(#h)"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M63.65 7.943h6.334v2.102h-3.699v1.44h3.469v1.95h-3.469v1.431h3.699v2.103h-6.335z",
    transform: "scale(.26458)",
    clipPath: "url(#i)"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M79.816 7.696h2.493l4.392 6.221-1.964-1.119h1.223V7.696h2.991v9.976H86.49l-4.41-6.304 1.956 1.118h-1.223v5.186h-2.991V7.696Z",
    fill: "#89888e",
    transform: "scale(.26458)",
    clipPath: "url(#j)"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M90.36 7.696h7.184v2.323h-4.192v1.591h3.932v2.155h-3.932v1.583h4.192v2.323H90.36z",
    fill: "#89888e",
    transform: "scale(.26458)",
    clipPath: "url(#k)"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M101.776 7.696h2.822v2.375h-.976l-2.024 7.596H98.45l3.326-9.976zm-.616 5.922h4.981l.62 2.068h-6.225l.62-2.068zm2.519-3.547V7.696h1.851l3.325 9.976h-3.147l-2.025-7.596z",
    fill: "#89888e",
    transform: "scale(.26458)",
    clipPath: "url(#l)"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M109.771 7.696h4.586c.876 0 1.613.13 2.212.394.598.264 1.053.646 1.365 1.153.312.508.468 1.128.468 1.865v.013a3.34 3.34 0 0 1-.446 1.708c-.299.516-.694.893-1.188 1.127l1.934 3.711h-3.347l-1.609-3.278h-.98v3.278h-2.991V7.695Zm4.24 4.63c.403 0 .728-.113.975-.338.243-.226.369-.52.369-.885v-.013c0-.364-.126-.659-.373-.889-.252-.23-.573-.342-.967-.342h-1.249v2.467h1.249z",
    fill: "#89888e",
    transform: "scale(.26458)",
    clipPath: "url(#m)"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgAwesomeNear);
export default __webpack_public_path__ + "static/media/awesome_near.f95df7cdf9c11e10674e7e5459cc6228.svg";
export { ForwardRef as ReactComponent };